@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.drivertargets
import com.narbase.letsgo.dto.core.KmmLong

class DriverTargetRideDto (
    val id: KmmLong?,
    val driverTargetId: KmmLong,
    val rideId: KmmLong,
)